import {ENVIRONMENT} from "../../environments/environment";
import * as CryptoJS from "crypto-js";
import * as Raven from "raven-js";
import {TranslateService} from "@ngx-translate/core";
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";


/**
 * Class > HelperService
 */
@Injectable()
export class HelperService {

	/**
	 * @type {boolean}
	 */
	public router_spinner: boolean = false;


	/**
	 * @param translateService
	 * @param toastrService
	 */
	constructor(
		public translateService?: TranslateService,
		private toastrService?: ToastrService,
	) {

		if (!ENVIRONMENT.fingerprint) {
			ENVIRONMENT.fingerprint = this.getBrowserFingerprint();
		} // end if

	}


	/**
	 * Function > getBrowserFingerprint
	 * @return string
	 */
	getBrowserFingerprint(): string {

		let STR_fingerprint = "";
		// STR_fingerprint+="Resolution:"+window.screen.availWidth+"x"+window.screen.availHeight+"\n";
		STR_fingerprint += "ColorDepth:" + screen.colorDepth + "\n";
		STR_fingerprint += "UserAgent:" + navigator.userAgent + "\n";
		STR_fingerprint += "Timezone:" + (new Date()).getTimezoneOffset() + "\n";
		STR_fingerprint += "Language:" + navigator.language + "\n";
		/*document.cookie = "sFP";
		if (typeof navigator.cookieEnabled != "undefined"
			&& navigator.cookieEnabled == true
			&& document.cookie.indexOf("sFP") != -1)
		{
			STR_fingerprint += "Cookies:true\n";
		} else
		{
			STR_fingerprint += "Cookies:false\n";
		} // end if*/

		// STR_fingerprint+="Plugins:"+$.map(navigator.plugins, function(oElement)
		// {
		// 	return "\n"+oElement.toString();
		// });
		return CryptoJS.MD5(STR_fingerprint).toString();

	} // end function getBrowserFingerprint


	/**
	 * Function > generateKey
	 * @return string
	 */
	generateKey(): string {

		let STR_key = "";
		let STR_hex = "0123456789abcdef";

		for (let INT_idx = 0; INT_idx < 16; INT_idx++) {
			STR_key += STR_hex.charAt(Math.floor(Math.random() * 16));
		} // end for

		return STR_key;

	} // end function generateKey


	/**
	 * Function > encrypt
	 * @param {string} STR_string
	 * @param {boolean} BOO_uri_encode
	 * @return string
	 */
	encrypt(STR_string, BOO_uri_encode = false): string {

		// encrypted access
		let OBJ_encrypted =
			CryptoJS.AES.encrypt(
				STR_string,
				CryptoJS.lib.WordArray.create(ENVIRONMENT.fingerprint),
				{
					keySize: 16,
					iv: CryptoJS.lib.WordArray.create(CryptoJS.lib.WordArray.random(16)),
					mode: CryptoJS.mode.CBC,
					padding: CryptoJS.pad.Pkcs7
				});

		if (BOO_uri_encode) {
			return encodeURIComponent(OBJ_encrypted.toString());
		} // end if

		return OBJ_encrypted.toString();

	} // end function encrypt


	/**
	 * Function > decrypt
	 * @param {string} STR_string
	 * @param {boolean} BOO_uri_decode
	 * @return string
	 */
	decrypt(STR_string, BOO_uri_decode = false): string {
		if (STR_string) {
			if (BOO_uri_decode) {
				STR_string = decodeURIComponent(STR_string);
			} // end if

			let OBJ_decrypted =
				CryptoJS.AES.decrypt(
					STR_string,
					CryptoJS.lib.WordArray.create(ENVIRONMENT.fingerprint),
					{
						keySize: 16,
						iv: CryptoJS.lib.WordArray.create(CryptoJS.lib.WordArray.random(16)),
						mode: CryptoJS.mode.CBC,
						padding: CryptoJS.pad.Pkcs7
					});

			return OBJ_decrypted.toString(CryptoJS.enc.Utf8)

		} // end if

		return '';

	} // end function decrypt


	/**
	 * Function > get
	 * @param {string} STR_name
	 * @param {boolean} BOO_encrypted
	 * @param {boolean} BOO_uri_encode
	 * @return any
	 */
	getFromLocalstorage(STR_name: string, BOO_encrypted: boolean = false, BOO_uri_encode = false): any {

		let MIX_return = null;
		if (BOO_encrypted && localStorage.getItem(STR_name)) {

			MIX_return = localStorage.getItem(STR_name);
			if (BOO_uri_encode) {
				MIX_return = encodeURIComponent(MIX_return);
			} // end if

		} else {

			if (localStorage.getItem(STR_name) && !ENVIRONMENT.helper[STR_name]) {

				try {
					ENVIRONMENT.helper[STR_name] = JSON.parse(this.decrypt(localStorage.getItem(STR_name)));
				} catch (OBJ_exception) {

					// send error to bug tracking system
					Raven.captureException(OBJ_exception);

					// complete purge local storage - logs the user out immediately
					localStorage.clear();
				}

			} // end if

			MIX_return = ENVIRONMENT.helper[STR_name];

		} // end if

		return MIX_return;

	} // end function get


	/**
	 * Function > set
	 * @param {string} STR_name
	 * @param {any} MIX_content
	 * @param {boolean} BOO_storage
	 * @return void
	 */
	setInLocalstorage(STR_name: string, MIX_content: any, BOO_storage: boolean = true): void {
		// console log
		this.log
		(
			{class: 'HelperService', function: 'set'},
			'name: ' + STR_name,
			MIX_content
		);

		let STR_string;
		let OBJ_object;

		if (typeof MIX_content === 'object') {
			STR_string = JSON.stringify(MIX_content);
			OBJ_object = MIX_content;
		} else if (typeof MIX_content === 'string') {
			STR_string = MIX_content;
			OBJ_object = JSON.parse(MIX_content);
		} // end if

		// save in local storage
		if (BOO_storage) {
			localStorage.setItem(STR_name, this.encrypt(STR_string));
		} // end if

		ENVIRONMENT.helper[STR_name] = OBJ_object;

		// console log
		this.log
		(
			{class: 'HelperService', function: 'set'},
			'set ' + STR_name + 'to local storage',
			ENVIRONMENT.helper[STR_name]
		);

	} // end function set


	/**
	 * Function > removeFromStorage
	 * @param STR_name
	 */
	removeFromStorage(STR_name?: string): void {

		if (arguments.length == 1) {
			// remove from local storage
			localStorage.removeItem(STR_name);
			ENVIRONMENT.helper[STR_name] = null;
		} else {
			// remove all items
			localStorage.clear();
		} // end if

	} // end function removeFromStorage


	/**
	 * Function > log
	 * @param {any} MIX_message
	 * @param {any[]} ARR_optional_params
	 */
	log(MIX_message?: any, ...ARR_optional_params: any[]) {
		console.log(MIX_message, ...ARR_optional_params);
	} // end function log


	/**
	 * Function > error
	 * @param {any} MIX_message
	 * @param {any[]} ARR_optional_params
	 */
	error(MIX_message?: any, ...ARR_optional_params: any[]) {
		console.error(MIX_message, ARR_optional_params);
	} // end function error


	/**
	 * Function > logWithClassAndFunction
	 * @param STR_class
	 * @param STR_function
	 * @param {any[]} ARR_optional_params
	 */
	logWithClassAndFunction(STR_class: string, STR_function: string, ...ARR_optional_params: any[]) {
		this.log({
			class: STR_class,
			function: STR_function
		}, ARR_optional_params);
	} // end function log


	/**
	 * Function > getInitials
	 * @param {string} STR_string
	 * @return {string}
	 */
	getInitials(STR_string: string): string {
		return STR_string
			.split(/[ -]/)
			.map((x) => {
				return (x.substring(0, 1).toUpperCase());
			})
			.join('');
	} // end function getInitials


	/**
	 * Function > getLabelName
	 * @param {object} OBJ_item
	 * @return {string}
	 */
	getLabelName(OBJ_item): string {

		if (typeof OBJ_item.label !== 'undefined') {
			return OBJ_item.label;
		} else if (typeof OBJ_item.name !== 'undefined') {
			return OBJ_item.name.toLocaleLowerCase();
		} else if (typeof OBJ_item.title !== 'undefined') {
			return OBJ_item.title.toLocaleLowerCase();
		} else if (typeof OBJ_item.data !== 'undefined') {
			return OBJ_item.data.toLocaleLowerCase();
		}

		return '';

	} // end Function getLabelName


	/**
	 * Function > addRenderer
	 *
	 * @desc Depending on the data type, adds the appropriate renderer to the column, which ensures that this type is displayed correctly
	 * @param ARR_columns
	 */
	addRenderer(ARR_columns) {

		// go through columns and adjust representation according to data type
		ARR_columns.forEach((OBJ_column) => {

			// translate title
			OBJ_column.title = this.translateService.instant(
				this.getLabelName(OBJ_column)
			);
			let self = this;

			switch (OBJ_column.type) {
				case 'json':
					OBJ_column.render = function (JSON_data, STR_type, OBJ_row) {
						if (JSON_data) {
							return JSON.stringify(JSON_data);
						} // end if
						return null;
					};
					break;

				case 'number':
					OBJ_column.render = function (MIX_data, STR_type, OBJ_row) {
						return ((MIX_data && MIX_data.length) ? Number(MIX_data) : MIX_data);
					};
					break;
				case 'string':
					OBJ_column.render = $.fn.dataTable.render.text();
					// Do nothing for now
					break;

				case 'boolean':
					OBJ_column.render = function (BOO_data, STR_type, OBJ_row) {
						return "<div class='tig-check disabled" + ((BOO_data) ? " checked" : "") + "'>" +
							"<input type='checkbox' value='1' disabled='disabled'" + (BOO_data ? " checked='checked'" : "") + " /></div>";
					};
					break;

				case 'array':
					OBJ_column.render = function (ARR_data, STR_type, OBJ_row) {
						let STR_value_property = '';
						ARR_data.forEach((OBJ_item) => {
							STR_value_property += this.OBJ_contents_helper.getValue("title", OBJ_item) + ", ";
						});

						return STR_value_property.replace(/<\/?[^>]+(>|$)/g, "");
					};
					break;

				case 'date':
					OBJ_column.render = function (STR_data, STR_type, OBJ_row) {
						if (STR_data) {
							return self.getDate('%d.%M.%Y', STR_data, STR_type);
						} // end if
						return null;
					};
					break;

				case 'datetime':
					OBJ_column.render = function (STR_data, STR_type, OBJ_row) {
						if (STR_data) {
							return self.getDate('%d.%M.%Y %H:%m:%s', STR_data, STR_type);
						} // end if
						return null;
					};
					break;

				// Inhalt der jeweiligen Spalten soll uebersetzt werden
				case 'translate':
					let OBJ_translate_service = this.translateService;

					OBJ_column.render = function (MIX_data, STR_type, OBJ_row) {
						return OBJ_translate_service.instant(MIX_data);
					};

					break;
				default:
					OBJ_column.render = $.fn.dataTable.render.text();
					break;
			} // end switch

		}); // end forEach

		return ARR_columns;

	} // end function addRenderer


	/**
	 * Function > getDate
	 *
	 * @desc Datetime formatter, format either the current timestamp, or a provided datetime into a specified format
	 * @param {string} STR_format Format to use, (defaults to %d.%M.%Y %H:%m:%s)
	 * @param {numeric} STR_date
	 * @param {string} STR_type
	 * @param {boolean} BOO_no_pad Do not pad the numbers (results padded by default)
	 * @returns {string} Formatted date
	 */
	public getDate(STR_format, STR_date, STR_type, BOO_no_pad = false) {

		// Default to the current unix timestamp
		if (!STR_date) {
			STR_date = $.now();
		} // end if

		// Default format is day-Month-Year Hour:min:sec
		if (!STR_format) {
			STR_format = "%d-%M-%Y %H:%m:%s";
		} // end if

		let OBJ_date: Date = new Date(STR_date);

		// Convert '9' to '09', but leave '10' as '10'
		function pad(INT_value) {
			return (INT_value.toString().length < 2) ? "0" + INT_value : INT_value;
		} // end function pad

		if (STR_type === 'display') {
			// vgl P2SD-9750 - local time wasn't considered
			return OBJ_date.toLocaleString(this.translateService.currentLang);

			// Return the processed result of the timestamp/format
			// return STR_format.replace(/%([a-zA-Z])/g, function (_, STR_fmt_code)
			// {
			//
			// 	switch (STR_fmt_code)
			// 	{
			//
			// 		case "Y":
			// 			return OBJ_date.getUTCFullYear();
			// 		case "M":
			// 			return BOO_no_pad
			// 				? OBJ_date.getUTCMonth() + 1
			// 				: pad(OBJ_date.getUTCMonth() + 1);
			// 		case "d":
			// 			return BOO_no_pad
			// 				? OBJ_date.getUTCDate()
			// 				: pad(OBJ_date.getUTCDate());
			// 		case "H":
			// 			return BOO_no_pad
			// 				? OBJ_date.getUTCHours()
			// 				: pad(OBJ_date.getUTCHours());
			// 		case "m":
			// 			return BOO_no_pad
			// 				? OBJ_date.getUTCMinutes()
			// 				: pad(OBJ_date.getUTCMinutes());
			// 		case "s":
			// 			return BOO_no_pad
			// 				? OBJ_date.getUTCSeconds()
			// 				: pad(OBJ_date.getUTCSeconds());
			// 		default:
			// 			throw new Error("Unsupported format code: " + STR_fmt_code);
			//
			// 	} // end switch

			// });

		} // end if

		if (STR_type === 'sort') {
			return OBJ_date.getTime();
		} // end if

		return null;

	} // end function getDate

	/**
	 * Function > goBack
	 * @desc Take a step back in the navigation
	 */
	goBack(OBJ_router: Router, BOO_isstandalonedetail = false): void {

		// Navigiere zu Listingansicht
		let STR_url = OBJ_router.url;

		// Keine Listingansicht vorhanden, navigiere zu Startseite
		if (BOO_isstandalonedetail) {
			OBJ_router.navigate([
				"/starter"
			]);
		}
		// navigiere zu Listenansicht
		else {
			OBJ_router.navigate([
				STR_url.slice(0, STR_url.lastIndexOf("/"))
			], {queryParams: {keepState: true}});
		} // end if

	} // end function goBack


	/**
	 * Function > getPatterns
	 */
	public getPatterns(): object {
		return ENVIRONMENT.patterns;
	} // end function getPatterns


	/**
	 * Function > setPatterns
	 */
	public setPatterns(OBJ_patterns): void {
		ENVIRONMENT.patterns = OBJ_patterns;
	} // end function setPatterns


	/**
	 * Function > getPatternByName
	 * @param {string} STR_name
	 * @return string|null
	 */
	public getPatternByName(STR_name): string {

		let MIX_pattern = this.getProperty(STR_name, this.getPatterns());
		if (typeof MIX_pattern === "string") {
			return MIX_pattern;
		} // end if

		return null;

	} // end function getPatternByName


	/**
	 * Function > getPatternByRegex
	 * @desc liefert volle Bezeichnung des pattern zurueck, das zu uebergebenem regex passt
	 * @param STR_regex: string
	 * @return string|null
	 */
	public getPatternByRegex(STR_regex: string): string {
		// wenn nichts passt gebe einfach regex zurueck
		let STR_return = STR_regex;
		let OBJ_pattern_keys = this.getPatterns();
		// Iteriere ueber alle angelegten Patterns
		for (let STR_outer_key of Object.keys(OBJ_pattern_keys)) {
			let OBJ_patterns = OBJ_pattern_keys[STR_outer_key];
			// jetzt iteriere ueber verfuegbaren regex
			for (let STR_inner_key of Object.keys(OBJ_patterns)) {
				if (OBJ_patterns[STR_inner_key] === STR_regex) {
					// gebe Pfad zu regex zurueck
					STR_return = STR_outer_key + "." + STR_inner_key;
				} // end if
			} // end for
		}
		return STR_return;

	} // end function getPatternByRegex


	/**
	 * Function > getProperty
	 *
	 * @desc A function to take a string written in dot notation style, and use it to
	 * find a nested object property inside of an object.
	 *
	 * @param {string} STR_property_name
	 * nested A dot notation style parameter reference (ie "urls.small")
	 * @param {object} OBJ_object
	 * object (optional) The object to search
	 *
	 * @return the value of the property
	 */

	public getProperty(STR_property_name, OBJ_object): any {

		let ARR_parts = STR_property_name.split("."),
			INT_length = ARR_parts.length,
			INT_idx,
			MIX_property = OBJ_object || this;

		for (INT_idx = 0; INT_idx < INT_length; INT_idx++) {
			if (typeof MIX_property[ARR_parts[INT_idx]] !== "undefined") {
				MIX_property = MIX_property[ARR_parts[INT_idx]];
			} // end if
		} // end for

		return MIX_property;

	} // end function getProperty

	/**
	 * Function > generateHash
	 * @param OBJ_params
	 * @param OBJ_body
	 * @param STR_token
	 */

	public generateHash(OBJ_params: object, OBJ_body: object, STR_token: string) {
		let OBJ_return = {
			event: 'hash',
			params: undefined,
			body: undefined
		};

		if (OBJ_params) {
			OBJ_return.params = this.hashParams(OBJ_params, STR_token);
		} // end if

		if (OBJ_body) {
			// Bilder- oder Dateienupload
			if (OBJ_body instanceof FormData) {
				OBJ_body.set('hash', this.generateChecksum(OBJ_body.get('json').toString(), STR_token));
			} else {
				OBJ_return.body = {
					'hash': this.generateChecksum(JSON.stringify(OBJ_body), STR_token),
					'data': JSON.stringify(OBJ_body)
				};
			} // end if

		} // end if

		return OBJ_return;

	} // end function generateHash

	/**
	 *
	 * @param OBJ_params
	 * @param STR_token
	 */
	public hashParams(OBJ_params, STR_token: string) {
		let ARR_keys = Object.keys(OBJ_params).sort();
		let STR_params_to_hash = "";
		ARR_keys.forEach((key) => {

			if (STR_params_to_hash != "") {
				STR_params_to_hash = STR_params_to_hash + "&";
			} // end if

			STR_params_to_hash = STR_params_to_hash + key + "=" + OBJ_params[key];
		});

		return this.generateChecksum(STR_params_to_hash, STR_token);
	} // end function hashParams

	/**
	 *
	 * @param OBJ_body
	 * @param STR_token
	 */
	public hashBody(OBJ_body, STR_token: string) {
		// Bilder- oder Dateienupload
		if (OBJ_body instanceof FormData) {
			OBJ_body.set('hash', this.generateChecksum(OBJ_body.get('json').toString(), STR_token));
			return OBJ_body;
		} else {
			return {
				'hash': this.generateChecksum(JSON.stringify(OBJ_body), STR_token),
				'data': JSON.stringify(OBJ_body)
			};
		} // end if

	} // end function hashBody


	/**
	 * create SHA256 with salt
	 *
	 * @param STR_message
	 * @param STR_salt
	 */
	generateChecksum(STR_message: string, STR_salt: string) {
		return CryptoJS.SHA256(STR_message + STR_salt).toString();
	} // end generateChecksum


	/**
	 * @param text
	 * @param translate_key
	 */
	copyStringToClipboard(text: string, translate_key: string): void {

		// create new element
		let el = document.createElement('textarea');

		// set value (string to be copied)
		el.value = text;
		document.body.appendChild(el);

		// select text inside element
		el.select();

		// copy text to clipboard
		document.execCommand('copy');

		// remove temporary element
		document.body.removeChild(el);

		if (typeof translate_key !== 'undefined' && translate_key.length > 0) {
			// output success
			this.toastrService.success(this.translateService.instant(translate_key));
		}

	}


} // end class HelperService
